import { useQuery } from '@tanstack/react-query';
import axios, { isAxiosError } from 'axios';
import { t } from 'i18next';

import { Structure } from 'models';

type Defaults = {
    structureId: number;
    targetTime: number;
    targetValue: number;
    carbonFootprintElectricity: number;
    volumeOfConcrete: number;
    surfaceOfFormwork: number;
    costsOfElectricity: number;
    ambientTemperature: number;
    freshConcreteTemperature: number;
    priceOfConcrete: number;
}

type TargetSettingsResponse = {
    data: {
        structures: Structure[];
        defaultValues: Defaults[];
    }
}

type UseTargetSettingsResult = {
    structures: Structure[];
    defaultValues: Defaults[];
    isLoading: boolean;
    errorMessage: string | null;
}

const fetchTargetSettings = async () => {
    const url = `${import.meta.env.VITE_APP_API_URL}/target-settings`;
    const response = await axios.get<TargetSettingsResponse>(url);
    return response.data;
};

export const useTargetSettings = (): UseTargetSettingsResult => {
    const { data, isLoading, error } = useQuery<TargetSettingsResponse, Error>({
        queryKey: ['targetSettings'],
        queryFn: () => fetchTargetSettings(),
        staleTime: Infinity
    });

    const structures = data?.data.structures || [];
    const defaultValues = data?.data.defaultValues || [];
    const errorMessage = error && (isAxiosError(error) ? error.message : t('errorLoadingConcreteMixtures'));

    return {
        structures,
        defaultValues,
        isLoading,
        errorMessage
    };
};